import { useQuery, UseQueryOptions } from 'react-query';
import { getEmploymentAgenciesValues } from 'RestAPIs/employment-agencies';

interface UseGetEmploymentAgenciesArgs {
  startDate: string;
  endDate?: string;
}

const useGetEmploymentAgencies = (
  { startDate, endDate }: UseGetEmploymentAgenciesArgs,
  options?: UseQueryOptions<any, unknown, any>
) => {
  const { data, isFetching, isError, refetch } = useQuery({
    queryKey: ['employmentAgencies', 'list', startDate, endDate],
    queryFn: async () => {
      const { data } = await getEmploymentAgenciesValues({
        startDate,
        endDate
      });
      return data;
    },
    enabled: !!startDate && !!endDate,
    ...options
  });
  return { data, isFetching, isError, refetch };
};

export default useGetEmploymentAgencies;
